// extracted by mini-css-extract-plugin
export default {"sidebar_main":"sidebar_sidebar_main__6dw7M","sidebar_object":"sidebar_sidebar_object__3fAjK"};